module.exports = __webpack_public_path__ + "static/6550197b-f9dd-4cba-be27-0ea4fc7a1cc8-450.bcc8e533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/barkVase-cinnamon/6550197b-f9dd-4cba-be27-0ea4fc7a1cc8-450.jpg
// module id = 895
// module chunks = 168707334958949